import { Common } from '@stockbit/ui';
import { timelines } from '../constants';
import {
  AboutContainer,
  AboutContainerInner,
  Paragraph,
  Title,
} from '../styled';
import { TimelineBox, Timeline, TimelineTitle, CompanyInfo } from './styled';

const { Text } = Common;

const AboutUs = () => (
  <AboutContainer>
    <AboutContainerInner>
      <TimelineBox>
        {timelines.map((timeline) => (
          <Timeline key={timeline.year}>
            <Text as="p" size="16px">
              {timeline.year}
            </Text>
            <TimelineTitle>{timeline.desc}</TimelineTitle>
          </Timeline>
        ))}
      </TimelineBox>
      <CompanyInfo>
        <Title>Informasi Perusahaan</Title>
        <Paragraph>
          Berdiri sejak tahun 1990 dengan nama PT Mahakarya Artha Sekuritas dan
          terdaftar di OJK dengan nomor izin KEP-132/PM/1992, PT Mahakarya Artha
          Sekuritas terus berkomitmen dalam meningkatkan jumlah investor di
          Indonesia untuk membantu perekonomian nasional. Pada Desember 2021, PT
          Mahakarya Artha Sekuritas telah resmi diakuisisi dan berganti nama
          menjadi PT Stockbit Sekuritas Digital.
        </Paragraph>
        <Paragraph>
          Sebagai perusahaan efek yang telah memiliki pengalaman, PT Stockbit
          Sekuritas Digital berkomitmen untuk terus melakukan inovasi dan
          memberikan layanan serta pengalaman investasi yang mudah, aman dan
          terpercaya bagi investor melalui teknologi kelas dunia untuk dapat
          memfasilitasi masyarakat dalam berinvestasi secara mudah di pasar
          modal Indonesia melalui layanan perdagangan saham online yang modern.
          Melalui aplikasi investasi sosial Stockbit investor dapat berdiskusi
          sekaligus melakukan transaksi saham secara daring. Pembukaan akun
          rekening sekuritas juga dapat dilakukan melalui aplikasi Stockbit yang
          dapat diunduh melalui Playstore dan Appstore.
        </Paragraph>
      </CompanyInfo>
    </AboutContainerInner>
  </AboutContainer>
);

export default AboutUs;
